import React, { useMemo } from 'react';
import Message from 'common/components/CopyMagic/generators/ConversationAssistant/components/Message';
import { MESSAGE_DATA_ROLES } from 'common/components/CopyMagic/constants';
import { useUiResourceContext } from 'common/components/CopyMagic/contexts';
import { useMessagesContext } from 'common/components/CopyMagic/contexts/MessagesContext';
import useAiConsent from '../../hooks/useAiConsent';

const MessagesDisplay = () => {
  const { aiConsentRequired } = useAiConsent();
  const { messages, findLastMessageBy } = useMessagesContext();
  const { loading } = useUiResourceContext();

  const messagesList = useMemo(() => {
    const [lastAssistantRoleKey] = findLastMessageBy({ role: MESSAGE_DATA_ROLES.ASSISTANT });
    const [lastUserRoleKey] = findLastMessageBy({ role: MESSAGE_DATA_ROLES.USER });

    return Array.from(messages.entries()).map(([key, messageItem], index, array) => {
      const last = index === array.length - 1;
      const lastOfRole = key === lastAssistantRoleKey || key === lastUserRoleKey;
      return <Message key={key} message={messageItem} last={last} lastOfRelated={lastOfRole} />;
    });
  }, [findLastMessageBy, messages]);

  const greeting = aiConsentRequired ? (
    <Message template="GreetingFirst" last={!messages.size} />
  ) : (
    <Message template="GreetingReturn" last={!messages.size} />
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {greeting}
      {messagesList}
      {loading && <Message template="Loading" />}
    </div>
  );
};

export default MessagesDisplay;
